import { render } from "./SolutionCard.vue?vue&type=template&id=1baeb80c&scoped=true"
import script from "./SolutionCard.vue?vue&type=script&lang=js"
export * from "./SolutionCard.vue?vue&type=script&lang=js"

import "./SolutionCard.vue?vue&type=style&index=0&id=1baeb80c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1baeb80c"]])

export default __exports__